import {
	ChangeDetectionStrategy,
	Component,
	HostBinding,
	Input
} from '@angular/core';

@Component({
	selector: 'vb-scrub-bar-current-time',
	changeDetection: ChangeDetectionStrategy.OnPush,
	template: ``,
	standalone: false,
	styleUrls: ['./VbScrubBarCurrentTime.Component.ng.less']
})
export class VbScrubBarCurrentTimeComponent {
	@Input() @HostBinding('style.width') public scrubBarPercentage: string;
}
